var validatorNamer = function validatorNamer(name) {
  return function (v) {
    return typeof v('', {}) === 'function' ? v(name) : v;
  };
};

var combineValidators = function combineValidators(validators) {
  return function () {
    for (var _iterator = validators, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var validator = _ref;
      var error = validator.apply(undefined, arguments);
      if (error) return error;
    }

    return undefined;
  };
};

export default (function (name, validate) {
  var namer = validatorNamer(name);
  return combineValidators(validate.map(namer));
});